// extracted by mini-css-extract-plugin
export default {"header":"credit-management-info_header__5XBK4","tableContainer":"credit-management-info_tableContainer__QPPL2","pdfIcon":"credit-management-info_pdfIcon__y40gp"};